var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentMiddleTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.162 103.475L274.275 10.084C270.758 3.361 263.379 0 256 0S241.242 3.361 237.725 10.084L188.838 103.475C80.076 127.467 0 208.012 0 304C0 418.906 114.594 512 256 512S512 418.906 512 304C512 208.012 431.924 127.467 323.162 103.475ZM256 496C123.664 496 16 409.869 16 304C16 285.732 22.604 156.553 199.559 117.494L251.9 17.504C252.287 16.764 253.926 16 256 16S259.713 16.764 260.1 17.504L312.441 117.494C489.396 156.553 496 285.732 496 304C496 409.869 388.336 496 256 496Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentMiddleTop);
export default __webpack_public_path__ + "static/media/comment-middle-top.02ac7a121872e75aeb464075fdcf8923.svg";
export { ForwardRef as ReactComponent };